import { ActionTypes } from '../constants/index';

export const fetchManageVersion = (payload: any) => ({
  type: ActionTypes.MANAGE_VERSION_LIST_REQUEST,
  payload,
});
